import React from 'react';

const BASE = 15;

const st = {
  card: {
    borderRadius: 12,
    border: '2px solid rgba(99, 102, 241, 0.15)',
    background: 'linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%)',
    padding: 12,
    display: 'grid',
    gap: 6,
    boxShadow: '0 2px 6px rgba(99, 102, 241, 0.1)',
    fontFamily: 'system-ui, "PingFang TC", "Microsoft JhengHei", sans-serif',
    color: '#111',
  },
  time: {
    fontSize: 24,
    fontWeight: 900,
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
    lineHeight: 1,
  },
  rowLine: { fontSize: BASE + 1, lineHeight: 1.2, wordBreak: 'break-word' },
  alertGreen: {
    fontSize: BASE + 1,
    lineHeight: 1.4,
    color: '#065f46',
    fontWeight: 800,
    whiteSpace: 'pre-wrap',
    padding: '8px 12px',
    background: 'linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%)',
    borderRadius: 8,
    border: '1px solid #10b981',
  },
  alertPurple: {
    fontSize: BASE + 1,
    lineHeight: 1.4,
    color: '#5b21b6',
    fontWeight: 800,
    whiteSpace: 'pre-wrap',
    padding: '8px 12px',
    background: 'linear-gradient(135deg, #e9d5ff 0%, #ddd6fe 100%)',
    borderRadius: 8,
    border: '1px solid #8b5cf6',
  },
};

function fmtEventTime(a) {
  const start = String(a.activity_time || '').trim();
  const end = String(a.end_time || '').trim();
  if (start && end) return `${start} ~ ${end}`;
  return start || '';
}

/** 對齊 BanquetInfoPlaceholder 活動列表單卡（/admin/banquet） */
export default function WeeklyActivityPreviewBanquetCard({ activity }) {
  const a = activity || {};
  const timeText = fmtEventTime(a);

  return (
    <article style={st.card}>
      <div style={st.time}>{timeText || '--:--'}</div>
      <div style={st.rowLine}>
        <b>{a.name || '（活動名稱）'}</b>
      </div>
      <div style={st.rowLine}>
        場地：<b>{a.venue || '-'}</b>
      </div>
      <div style={st.rowLine}>
        負責人：<b>{a.organizer || '-'}</b>
      </div>
      {a.internal_brief && (
        <div style={st.rowLine}>
          <b>簡述活動內容：</b>
          <span style={{ whiteSpace: 'pre-wrap' }}>{a.internal_brief}</span>
        </div>
      )}
      {a.equipment_need && (
        <div style={st.rowLine}>
          <b>需求設備：</b>
          <span style={{ whiteSpace: 'pre-wrap' }}>{a.equipment_need}</span>
        </div>
      )}
      {a.beverage_need && (
        <div style={st.alertGreen}>
          <b>需要飲品：</b>
          <span>{a.beverage_need}</span>
        </div>
      )}
      {a.handover_notes && (
        <div style={st.alertPurple}>
          <b>交接事項：</b>
          <span>{a.handover_notes}</span>
        </div>
      )}
    </article>
  );
}
